
      // Parse chatId from url
      const urlParams = new URLSearchParams(window.location.search);
      const chatId = urlParams.get('chatId');

      // Backwards compatibility with new playground URL
      if (!chatId) {
        chatId = window.location.pathname.replace('/', '');
      }

      // Create web component
      var chatbotElement = document.createElement('form-factory-chatbot');
      chatbotElement.setAttribute('chat', chatId);
      chatbotElement.setAttribute('opened', '');
      document.body.append(chatbotElement);
    